import NotificationSubscriptionApiUrls from 'src/apiUrls/NotificationSubscriptionApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React from 'react'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import pathMap from 'src/paths/PathMap_Notification'
import { useHistory } from 'react-router-dom'

const {
  form: { CngEditForm }
} = components

function EditPage({ showNotification }) {
  const { id } = useParams();
  const history = useHistory();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngEditForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          showNotification={showNotification}
          bodySection={
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
            />
          }
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          fetch={{
            url: NotificationSubscriptionApiUrls.GET
          }}
          update={{
              url: NotificationSubscriptionApiUrls.PUT,
              successRedirect: pathMap.NOTIFICATION_SUBSCRIPTION_LIST_VIEW,
              onPostSubmitSuccess: () => {
                  history.push(pathMap.NOTIFICATION_SUBSCRIPTION_LIST_VIEW)
              }
          }}
          id={id}
        />
      </Grid>
    </Grid>
  )
}

export default EditPage
